import React, { useState, useCallback, useEffect } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Switch,
    FormControlLabel,
    styled,
    Card,
    Chip
} from '@mui/material';

import { green, grey, red } from "@mui/material/colors";

import { useNavigate, useParams } from "react-router-dom";
// import { useFormik } from 'formik';
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonRestricted from '../../common/CommonRestricted';
import CommonJsonViewer from "../../common/CommonJsonViewer";

import { useSchedulers, schedulerTypes, targetTypes } from '../../../hooks/api/useSchedulers';
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
// import { initialValues, validationSchema } from "../../../schema/scheduler/taskSchema";
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

import { useAppContextFeatures } from "../../../context/AppContext";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 100,
    height: 100,
    opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

const StyledLabel = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem',
    fontWeight: 800
}))

const StyledContent = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem'
}))

const StyledDivider = styled(Divider)(({ theme }) => ({
    mt: 1,
    mb: 0,
    borderStyle: 'dashed'
}))

export default function ViewLog({
    routeType
}) {

    const { id } = useParams();

    const { promptMessage } = useSystemPrompt();
    const { isLoading, get } = useSchedulers({ schedulerType: schedulerTypes.schedulerLog, targetType: targetTypes.schedulerLog });
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.scheduler.id, scopeTypes.scheduler.log.id)

    const navigate = useNavigate();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const { setSystemLoading } = useAppContextFeatures()

    const [data, setData] = useState()

    const loadData = useCallback(async (id) => {

        setSystemLoading(true);

        try {

            const { data } = await get({ id })
            // console.log('response?.data?.items', response?.data)
            setData(data)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }, [id])

    useEffect(() => {

        loadData(id);

    }, [])

    // const formik = useFormik({
    //     initialValues,
    //     validationSchema,
    //     enableReinitialize: true,
    //     onSubmit
    // });

    // const { values, errors, touched, handleChange, setFieldValue } = formik;

    // const RenderForm = () => {
    //     return (

    //         <form onSubmit={formik.handleSubmit}>
    //             <StyledCard>
    //                 <Grid container spacing={1}>
    //                     <Grid item xs={12} sm={12} md={4} textAlign={"left"}>

    //                         <CommonSectionHeader
    //                             title={'Information'}
    //                             subTitle={"Provide details of the profile"}
    //                         />

    //                     </Grid>
    //                     <Grid item xs={12} sm={12} md={8}>
    //                         <Grid container spacing={1}>
    //                             <Grid item xs={12} sm={12} md={6} textAlign="left">
    //                                 <FormControlLabel
    //                                     control={
    //                                         <Switch
    //                                             name="status"
    //                                             checked={Boolean(values.status)}
    //                                             onChange={(event, checked) => {
    //                                                 setFieldValue("status", checked);
    //                                             }}
    //                                         />
    //                                     }
    //                                     label={
    //                                         Boolean(values.status) ? "Enabled" : "Disabled"
    //                                     }
    //                                 />
    //                             </Grid>

    //                             <Grid item xs={6}>
    //                                 {/* Space down */}
    //                             </Grid>

    //                             <Grid item xs={12} sm={12} md={6}>
    //                                 <TextField
    //                                     margin="dense"
    //                                     size="small"
    //                                     autoFocus
    //                                     fullWidth
    //                                     name={"taskKey"}
    //                                     label="Key"
    //                                     type="text"
    //                                     variant="outlined"
    //                                     value={values.taskKey}
    //                                     onChange={handleChange}
    //                                     error={touched.taskKey && Boolean(errors.taskKey)}
    //                                     helperText={touched.taskKey && errors.taskKey}
    //                                 />
    //                             </Grid>

    //                             <Grid item xs={12} sm={12} md={6}>
    //                                 <TextField
    //                                     margin="dense"
    //                                     size="small"
    //                                     autoFocus
    //                                     fullWidth
    //                                     name={"taskName"}
    //                                     label="Key"
    //                                     type="text"
    //                                     variant="outlined"
    //                                     value={values.taskName}
    //                                     onChange={handleChange}
    //                                     error={touched.taskName && Boolean(errors.taskName)}
    //                                     helperText={touched.taskName && errors.taskName}
    //                                 />
    //                             </Grid>

    //                             <Grid item xs={12} sm={12} md={12}>
    //                                 <TextField
    //                                     margin="dense"
    //                                     size="small"
    //                                     fullWidth
    //                                     name={"description"}
    //                                     label="Description"
    //                                     type="text"
    //                                     variant="outlined"
    //                                     multiline
    //                                     rows={3}
    //                                     value={values.description}
    //                                     onChange={handleChange}
    //                                     error={touched.description && Boolean(errors.description)}
    //                                     helperText={touched.description && errors.description}
    //                                 />
    //                             </Grid>
    //                         </Grid>
    //                     </Grid>
    //                 </Grid>
    //             </StyledCard>
    //             <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
    //                 <Grid item md={12} textAlign={"right"}>
    //                     <LoadingButton
    //                         type="submit"
    //                         // fullWidth
    //                         variant="contained"
    //                         sx={{
    //                             mt: 3,
    //                             mb: 2
    //                         }}
    //                         loading={isLoading}
    //                     >
    //                         Save Changes
    //                     </LoadingButton>
    //                 </Grid>
    //             </Grid>
    //         </form>

    //     )
    // }

    const RenderStatus = ({ item }) => {

        if (!data) return <></>

        return (
            <StyledCard>
                <Grid container spacing={1}>
                    {/* <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Log Status`}
                            subTitle={`Process status`}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid> */}

                    <Grid item xs={12} sm={12} md={12} sx={{}}>
                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={12} md={2} textAlign={"left"}>
                                <StyledLabel>Status</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} textAlign={"left"}>
                                {
                                    (item?.log_status === "1") ?
                                        <Chip
                                            size="small"
                                            label={`Success`}
                                            color="success"
                                            variant="contained"
                                        // sx={{
                                        //     backgroundColor: green[500],
                                        //     color: grey[0]
                                        // }}
                                        />
                                        :
                                        <Chip
                                            size="small"
                                            label={`Failed`}
                                            // color="primary"
                                            color="error"
                                            variant="outlined"
                                            sx={{
                                                // backgroundColor: red[500],
                                                // color: grey[0]
                                            }}
                                        />

                                }
                            </Grid>

                            <Grid item xs={12} sm={12} md={2} textAlign={"left"}>
                                <StyledLabel>Response</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} textAlign={"left"}>
                                <StyledContent>
                                    {
                                        item?.log_message
                                    }
                                </StyledContent>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderInfo = ({ item }) => {

        if (!data) return <></>

        return (
            <StyledCard sx={{ mt: 0 }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Information`}
                            subTitle={`Log Detail for the task performed`}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Task Name</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.scheduler_task_name}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Task Key</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.scheduler_task_key}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Flow Direction</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.flow_type.toUpperCase()}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Module</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.module}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Target</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.target}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Action</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.action}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Datetime</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.createdatetime}
                                </StyledContent>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderDataSource = ({ item }) => {

        if (!data) return <></>

        const sourceData = JSON.parse(item.source_data)

        // console.log('sourceData', sourceData)

        return (
            <StyledCard>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Source Extraction`}
                            subTitle={`Data source for task process`}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>Source Id</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {item?.source_id}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>Source Label</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {item?.source_type}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>Raw Data</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                {/* <StyledContent>
                                    {item.source_data}
                                </StyledContent> */}


                                {
                                    sourceData &&
                                    <CommonJsonViewer
                                        jsonObject={sourceData}
                                    />
                                }

                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderResponseDestination = ({ item }) => {

        if (!data) return <></>

        const destinationResult = JSON.parse(item.destination_result)

        // console.log('destinationResult', destinationResult)

        return (
            <StyledCard sx={{ mt: 1 }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Destination Response`}
                            subTitle={`Response destination after task process`}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>Destination Id</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {item?.destination_id}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>Destination Label</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {item?.destination_type}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>Raw Data</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                {/* <StyledContent>
                                    {item?.destination_result}
                                </StyledContent> */}

                                {
                                    destinationResult &&
                                    <CommonJsonViewer
                                        jsonObject={destinationResult}
                                    />
                                }

                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderDataSubmitDestination = ({ item }) => {

        if (!data) return <></>

        const destinationSubmitData = JSON.parse(item.destination_submit_data)

        // console.log('destinationSubmitData', destinationSubmitData)

        return (
            <StyledCard sx={{ mt: 1 }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Destination Submission`}
                            subTitle={`Data submission destination after task process`}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>

                            {/* <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>Destination Id</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {item?.destination_id}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>Destination Label</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {item?.destination_type}
                                </StyledContent>
                            </Grid> */}

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>Submitted Data</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                {/* <StyledContent>
                                    {item?.destination_result}
                                </StyledContent> */}

                                {
                                    destinationSubmitData &&
                                    <CommonJsonViewer
                                        jsonObject={destinationSubmitData}
                                    />
                                }

                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        if (!data) return <></>

        const { scheduler_log: item } = data

        return (
            <Grid container spacing={1} textAlign={"left"}>
                <Grid item md={12}>
                    <RenderStatus
                        item={item}
                    />
                </Grid>
                <Grid item md={5}>
                    <RenderInfo
                        item={item}
                    />
                </Grid>
                <Grid item md={7}>
                    <RenderDataSource
                        item={item}
                    />
                    <RenderDataSubmitDestination
                        item={item}
                    />
                    <RenderResponseDestination
                        item={item}
                    />
                </Grid>
            </Grid>
        )
    }

    const getBreadcumbActionMenus = () => {

        let props = []

        // if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id })) {
        //     props.push({
        //         displayText: "Edit Item",
        //         href: getRoute(`product/item/update/${id}`),
        //     })
        // }

        return props

    }

    return (
        <Box>

            {
                getHtmlHead({ routeType, title: headTitles.viewLog })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={`View Scheduler Log`}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: "Scheduler Logs",
                        props: {
                            href: getRoute("settings/scheduler/logs")
                        }
                    },
                    {
                        displayText: `View Scheduler Log #${id}`,
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            }

        </Box>
    )
}